import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  buttonsWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}));
